import { AUTHENTICATE_USER_ERROR, AUTHENTICATE_USER_SUCCESS,
    CREATE_NEW_LEARNER_ERROR, CREATE_NEW_LEARNER_SUCCESS,
    CREATE_NEW_TPO_USER_ERROR, CREATE_NEW_TPO_USER_SUCCESS, DEAUTHENTICATE_USER,
    PROCESS_VERIFICATION_CODE_ERROR, PROCESS_VERIFICATION_CODE_SUCCESS,
    SEND_VERIFICATION_EMAIL_ERROR, SEND_VERIFICATION_EMAIL_SUCCESS } from '../actions/index';
import { createReducer } from '../common/utils/ApiUtils';

const initialState = {
    learnerCreated: false,
    learnerResponse: null,
    tpoUserCreated: false,
    tpoUserResponse: null,
    userAuthenticated: false,
    authenticationResponse: null,
    userLoggedOut: false,
    userVerified: false,
    verificationResponse: null,
    confirmationEmailSent: false,
    emailSentResponse: null
};

export default createReducer(initialState, {
    [AUTHENTICATE_USER_SUCCESS]: (state, payload) => {
        return Object.assign({}, state, {
            userAuthenticated: true,
            authenticationResponse: payload
        });
    },
    [AUTHENTICATE_USER_ERROR]: (state, payload) => {
        return Object.assign({}, state, {
            userAuthenticated: false,
            authenticationResponse: payload
        });
    },
    [CREATE_NEW_LEARNER_SUCCESS]: (state, payload) => {
        return Object.assign({}, state, {
            learnerCreated: true,
            learnerResponse: payload
        });
    },
    [CREATE_NEW_LEARNER_ERROR]: (state, payload) => {
        return Object.assign({}, state, {
            learnerCreated: false,
            learnerResponse: payload
        });
    },
    [CREATE_NEW_TPO_USER_SUCCESS]: (state, payload) => {
        return Object.assign({}, state, {
            tpoUserCreated: true,
            tpoUserResponse: payload
        });
    },
    [CREATE_NEW_TPO_USER_ERROR]: (state, payload) => {
        return Object.assign({}, state, {
            tpoUserCreated: false,
            tpoUserResponse: payload
        });
    },
    [DEAUTHENTICATE_USER]: (state) => {
        return Object.assign({}, state, {
            userLoggedOut: true
        });
    },
    [PROCESS_VERIFICATION_CODE_SUCCESS]: (state, payload) => {
        return Object.assign({}, state, {
            userVerified: true,
            verificationResponse: payload
        });
    },
    [PROCESS_VERIFICATION_CODE_ERROR]: (state, payload) => {
        return Object.assign({}, state, {
            userVerified: false,
            verificationResponse: payload
        });
    },
    [SEND_VERIFICATION_EMAIL_SUCCESS]: (state, payload) => {
        return Object.assign({}, state, {
            confirmationEmailSent: true,
            emailSentResponse: payload
        });
    },
    [SEND_VERIFICATION_EMAIL_ERROR]: (state, payload) => {
        return Object.assign({}, state, {
            confirmationEmailSent: false,
            emailSentResponse: payload
        });
    }
});
